import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';

export default grapesjs.plugins.add('gjs-sub-tenant-dropdown', (editor, opts) => {
  let options = opts || {};
  let defaults = {
    pfx: 'sub-tenant-dropdown',
    blocks: ['sub-tenant-dropdown'],
    defaultStyle: true,
    label: 'Switch Sub Tenant (D)',
    category: 'CMS',
    type: 'sub-tenant-dropdown',
    labels: {
      labelNavItemSubMenuToggle: 'Sub Tenant Toggle',
      labelNavItemDropdownMenu: 'Sub Tenant Menu',
    },
    types: {
      nav_item_dropdown: 'navbar_item_dropdown',
      nav_item_dropdown_menu: 'navbar_item_dropdown_menu',
    },
  };
  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }
  loadComponents(editor, options);
  loadBlocks(editor, options);
});
